module.exports = __webpack_public_path__ + "static/media/48.74c50d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/48.png
// module id = 472
// module chunks = 0